var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNavigationVerticalRegular = function SvgNavigationVerticalRegular(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7468 21.2491V2.74914C17.7468 2.33493 18.0825 1.99914 18.4968 1.99914C18.8765 1.99914 19.1903 2.28129 19.2399 2.64737L19.2468 2.74914V21.2491C19.2468 21.6634 18.911 21.9991 18.4968 21.9991C18.1171 21.9991 17.8033 21.717 17.7536 21.3509L17.7468 21.2491V2.74914V21.2491ZM11.2498 21.2491V2.74914C11.2498 2.33493 11.5856 1.99914 11.9998 1.99914C12.3795 1.99914 12.6933 2.28129 12.7429 2.64737L12.7498 2.74914V21.2491C12.7498 21.6634 12.414 21.9991 11.9998 21.9991C11.6201 21.9991 11.3063 21.717 11.2566 21.3509L11.2498 21.2491V2.74914V21.2491ZM4.75 21.25L4.75 2.75C4.75 2.33579 5.08579 2 5.5 2C5.8797 2 6.19349 2.28215 6.24315 2.64823L6.25 2.75L6.25 21.25C6.25 21.6642 5.91421 22 5.5 22C5.1203 22 4.80651 21.7178 4.75685 21.3518L4.75 21.25L4.75 2.75L4.75 21.25Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavigationVerticalRegular, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/navigation-vertical-regular.49c1c97b.svg";
export { ForwardRef as ReactComponent };